// Entegrasyonlar › Platform Entegrasyonları sekmesi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'integrations.platforms';

export const integrationsPlatformsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Platform entegrasyonları nasıl yönetilir?'),
  intro: t(`${G}.intro`, 'Pazaryeri (Trendyol, N11, Hepsiburada, Pazarama, PttAVM), yemek sitesi (Yemeksepeti, Getir Food, Migros Food, Uber Eats) ve kargo (HepsiJet, DHL (MNG)) bağlantılarınızı buradan kurar, test eder ve silersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    toolbar: t(`${G}.regions.toolbar`, 'Ekle ve Stok Senkronizasyonu'),
    filters: t(`${G}.regions.filters`, 'Şube ve arama'),
    table: t(`${G}.regions.table`, 'Pazaryeri / Yemek / Kargo tabloları'),
  },
  steps: [
    {
      region: 'toolbar',
      title: t(`${G}.s1.title`, '1. Platform bağlayın'),
      text: t(`${G}.s1.text`, '"Pazaryeri Entegrasyonu Ekle", "Yemek Entegrasyonu Ekle" veya "Kargo Entegrasyonu Ekle" düğmesiyle pencereyi açın, platformu seçin ve platform panelinden aldığınız API bilgilerini girin. Kaydedilen bağlantı ilgili tabloya eklenir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Yemek sitesi bağlantıları şubeye bağlanır; tabloda Şube ve Mağaza / Marka sütunları görünür.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s2.title`, '2. Aynı platformda birden çok mağaza'),
      text: t(`${G}.s2.text`, 'Aynı platformdan birden fazla mağaza tanımlayabilirsiniz. Platform adının yanındaki sayı, o platformda kaç mağaza tanımlı olduğunu gösterir. Mağaza / marka adı girilmemiş kayıtlarda şube adı gösterilir ve "Adlandırılmamış" etiketi çıkar; kaydı düzenleyip gerçek marka adını yazın, böylece silerken ve ararken karıştırmazsınız.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Bağlantıyı bulun'),
      text: t(`${G}.s3.text`, 'Şube seçimi ve "Platform / Mağaza Adı" araması üç tabloyu birlikte süzer; arama platform adına, mağaza adına ve şube adına bakar. Filtrenin yanında kaç kaydın gösterildiği yazar.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Durumu kontrol edin ve test edin'),
      text: t(`${G}.s4.text`, 'Durum sütunu bağlantının Aktif / Pasif olduğunu gösterir. Satırın ⋮ menüsündeki "Bağlantıyı Test Et" (pazaryerleri, HepsiJet ve DHL (MNG) için) girilen bilgilerle platforma bağlanmayı dener ve sonucu ekranın altında gösterir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Pazaryerlerinde ⋮ menüsündeki "Ürünleri Getir", platformdaki ürünlerinizi listeler; bağlantı pasifse bu seçenek kapalıdır.'),
        t(`${G}.s4.tip2`, '"Düzenle" ile anahtarları, şubeyi ve mağaza adını değiştirebilirsiniz.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s5.title`, '5. Merkezi stok senkronizasyonu'),
      text: t(`${G}.s5.text`, '"Stok Senkronizasyonu" penceresi stok kartlarınızı aktif pazaryeri kanallarına eşler ve stok miktarlarını platformlara gönderir. Üstte Aktif Eşleşme, Kuyrukta Bekleyen, Hatalı eşleşme ve Son Senkron bilgileri görünür.'),
      tips: [
        t(`${G}.s5.tip1`, '"Otomatik Eslestir": e-ticarete açık ve barkodu ya da stok kodu olan ürünleri her aktif pazaryeri kanalına bağlar. Elle düzeltilmiş eşleşmelere dokunmaz.'),
        t(`${G}.s5.tip2`, '"Tumunu Senkronize Et" tüm eşleşmeleri gönderim kuyruğuna alır; satırdaki senkron simgesi tek ürünü gönderir. Sonuçlar "Senkron Gunlukleri" sekmesinde görünür.'),
        t(`${G}.s5.tip3`, 'Eşleşmenin durum etiketine tıklayarak eşleşmeyi pasif / aktif yapabilir, çöp kutusu simgesiyle silebilirsiniz. Silme için ayrıca onay sorulmaz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Bağlantıyı silin'),
      text: t(`${G}.s6.text`, '⋮ menüsündeki "Sil", onay sorduktan sonra bağlantıyı kaldırır; onay metninde mağaza adı da yazar. Bu işlem geri alınamaz; yeniden bağlamak için bilgileri baştan girmeniz gerekir. Bağlantıyı yalnız bir süre durdurmak istiyorsanız silmek yerine düzenleyip pasif yapmayı düşünün.'),
      tips: [
        t(`${G}.s6.tip1`, 'Düğmelerin yanındaki (i) bu rehberi yeniden açar.'),
      ],
    },
  ],
});
